
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { RestaurantWithEventSpaces } from "@/types/restaurant";
import type { FilterParams } from "@/types/filters";
import {
  filterByNeighborhood,
  filterBySearch,
  filterByEventType,
  filterByGroupSize,
  filterByPriceRange
} from "@/utils/filterOperations";

export const useFilteredRestaurants = (filters: FilterParams) => {
  return useQuery({
    queryKey: ['restaurants', filters],
    queryFn: async () => {
      console.log('useFilteredRestaurants - Starting filter operation with:', filters);
      
      const { data, error } = await supabase
        .from('restaurants')
        .select(`
          *,
          neighborhood:neighborhoods(
            id,
            name,
            city:cities(
              name,
              state
            )
          ),
          eventspaces (
            id,
            restaurant_id,
            space_name,
            capacity,
            event_types,
            description,
            photos,
            amenities:eventspace_amenities(
              amenity:amenities(*)
            ),
            pricing_tiers(*)
          )
        `)
        .eq('approval_status', 'approved');

      if (error) {
        console.error('useFilteredRestaurants - Error fetching restaurants:', error);
        throw error;
      }

      let filteredRestaurants = data as RestaurantWithEventSpaces[];

      // Apply filters in sequence
      filteredRestaurants = filterByNeighborhood(filteredRestaurants, filters.neighborhood);
      filteredRestaurants = filterBySearch(filteredRestaurants, filters.search);
      filteredRestaurants = filterByEventType(filteredRestaurants, filters.eventType);
      filteredRestaurants = filterByGroupSize(filteredRestaurants, filters.groupSize);
      filteredRestaurants = filterByPriceRange(filteredRestaurants, filters.priceRange);

      console.log('useFilteredRestaurants - Final results:', {
        initialCount: data.length,
        finalCount: filteredRestaurants.length,
        appliedFilters: Object.entries(filters).filter(([_, value]) => value).length
      });

      return filteredRestaurants;
    },
  });
};
